import HeaderOmniSearch from './component'
import { connect } from 'react-redux'
import {
  setSearchTerm,
  search,
  clearSearchTerm,
  setCurrentSearchTerm
} from '../../state/search/actions'

const mapDispatchToProps = (dispatch) => {
  return {
    setSearchTerms: (searchTerm) => dispatch(setSearchTerm(searchTerm)),
    search: () => dispatch(search()),
    clearSearchTerm: () => dispatch(clearSearchTerm()),
    setCurrentSearchTerm: (searchTerm) =>
      dispatch(setCurrentSearchTerm(searchTerm))
  }
}

export default connect(
  (state) => state.search,
  mapDispatchToProps
)(HeaderOmniSearch)
